import React, { useContext, useState } from 'react'
import Wizard from '../Wizard'
import { getAddSmsNumberParams } from '../../../utils/payload-generator'
import { useHistory, useLocation } from 'react-router-dom'
import { SmsNumberCampaignContext } from '../../../contexts/SmsNumberCampaignContext'
import { LoaderDialog } from 'functional-foundations'

const Create = () => {
    const [loading, setLoading] = useState(false)
    const {
        setNumberNetworkError,
        addNumber
    } = useContext(SmsNumberCampaignContext)

    const { pathname } = useLocation()
    const history = useHistory()

    const appPath = '/number-assignement'
    const basePath = `${pathname.split(appPath)[0]}`

    const onSubmitHandler = async (data) => {
        setLoading(true)
        try {
            setNumberNetworkError(null)
            const addParams = await getAddSmsNumberParams(data)
            await addNumber(addParams)
            history.push(basePath)
        } catch (err) {
            setNumberNetworkError('Something went wrong')
        } finally {
            setLoading(false)
        }
    }

    return <div>
        <Wizard onSubmit={onSubmitHandler} />
        <LoaderDialog
            isOpen={loading}
            title={'Processing your request...'}
            subtitle='Please wait!'
            data-testid='loader-dialog'
        />
    </div>
}

export default Create
